import * as api from "@lib/api";

export const login = ({ email, password }) => {
  return api.post("/auth/login", { email, password });
};
